import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'

export const paintCostOf1000DurstWGColumn: ShipmentColumn = {
    key: 'paintCostOf1000DurstWG',
    dataIndex: 'paintCostOf1000DurstWG',
    title: 'Стоимость краски 1000 шт. Durst, WG',
    width: 100,
    onCell: onCellStandard,
}

